import { AuthorizePaymentReviewType } from 'pages/AuthorizePaymentPage/types';
import {
  VendorPaymentDetails,
  AuthorizationPaymentResponse
} from 'pages/VendorPaymentResultPage/types';

export const authorizePaymentResult: AuthorizationPaymentResponse = {
  paymentDate: '01/01/2021',
  listOfVendors: [
    {
      vendorNo: '345',
      vendorName: 'Adidas',
      failReason: 'Server Down',
      documentId: '',
      amount: 3011.85,
      transactionId: '',
      listOfInvoices: []
    },
    {
      vendorNo: '789',
      vendorName: 'Porsche',
      failReason: '',
      documentId: '1104',
      amount: 5101,
      transactionId: 'Z675570',
      listOfInvoices: []
    },
    {
      vendorNo: '436',
      vendorName: 'Home Depot',
      failReason: '',
      documentId: '1105',
      amount: 15178.54,
      transactionId: '9765488',
      listOfInvoices: []
    },
    {
      vendorNo: '825',
      vendorName: 'Shell Oil Company',
      failReason: 'Internal Server Error',
      documentId: '',
      amount: 4083.23,
      transactionId: '',
      listOfInvoices: []
    },
    {
      vendorNo: '987',
      vendorName: 'Avon',
      failReason: '',
      documentId: '1106',
      amount: 894.54,
      transactionId: '4463577',
      listOfInvoices: []
    }
  ]
};
export const retryResult: VendorPaymentDetails[] = [
  {
    vendorNo: '345',
    vendorName: 'Adidas',
    failReason: 'Failed Again for Testing',
    documentId: '',
    amount: 3011.85,
    transactionId: '',
    listOfInvoices: []
  },
  {
    vendorNo: '825',
    vendorName: 'Shell Oil Company',
    failReason: '',
    documentId: '21234',
    amount: 4083.23,
    transactionId: '21234',
    listOfInvoices: []
  }
];
export const authorizationPaymentRequest: AuthorizePaymentReviewType = {
  paymentDate: '2021-11-28',
  accountingDate: '2021-11-28',
  postingDescription: 'abc',
  companyId: '1',
  authorizationPaymentList: [
    {
      vendorNo: 'T70435',
      vendorName: 'abc',
      invoiceId: 'Invoice 12345',
      amount: 12.34,
      invoiceDescription: 'xyz',
      invoiceDate: '2021-07-31',
      dueDate: '2021-07-31',
      discountAmount: 11.34,
      netAmount: 23.78,
      onHold: true
    },
    {
      vendorNo: 'T7043',
      vendorName: 'abc',
      invoiceId: 'Invoice 12346',
      amount: 12.34,
      invoiceDescription: 'xyz',
      invoiceDate: '2021-07-31',
      dueDate: '2021-07-31',
      discountAmount: 11.34,
      netAmount: 20.0,
      onHold: true
    },
    {
      vendorNo: 'TKIWA001',
      vendorName: 'pqr',
      invoiceId: 'Invoice 12347',
      amount: 10.0,
      invoiceDescription: 'xyz',
      invoiceDate: '2021-07-31',
      dueDate: '2021-07-31',
      discountAmount: 11.34,
      netAmount: 105.0,
      onHold: true
    },
    {
      vendorNo: 'TKIWA001',
      vendorName: 'pqr',
      invoiceId: 'Invoice 12348',
      amount: 10.0,
      invoiceDescription: 'xyz',
      invoiceDate: '2021-07-31',
      dueDate: '2021-07-31',
      discountAmount: 11.34,
      netAmount: 63.0,
      onHold: true
    },
    {
      vendorNo: 'T70463',
      vendorName: 'harry',
      invoiceId: 'Invoice 123',
      amount: 12.64,
      invoiceDescription: 'xyz',
      invoiceDate: '2021-07-31',
      dueDate: '2021-07-31',
      discountAmount: 11.34,
      netAmount: 34.0,
      onHold: true
    },
    {
      vendorNo: 'T70463',
      vendorName: 'harry',
      invoiceId: 'Invoice 124',
      amount: 12.34,
      invoiceDescription: 'xyz',
      invoiceDate: '2021-07-31',
      dueDate: '2021-07-31',
      discountAmount: 11.34,
      netAmount: 66.0,
      onHold: true
    },
    {
      vendorNo: 'TBOWK001',
      vendorName: 'potter',
      invoiceId: 'Invoice 01',
      amount: 12.34,
      invoiceDescription: 'xyz',
      invoiceDate: '2021-07-31',
      dueDate: '2021-07-31',
      discountAmount: 11.34,
      netAmount: 20.0,
      onHold: true
    },
    {
      vendorNo: 'TBOWK001',
      vendorName: 'potter',
      invoiceId: 'Invoice 02',
      amount: 12.34,
      invoiceDescription: 'xyz',
      invoiceDate: '2021-07-31',
      dueDate: '2021-07-31',
      discountAmount: 11.34,
      netAmount: 45.0,
      onHold: true
    }
  ]
};

export const authorizationPaymentResponse: AuthorizationPaymentResponse = {
  paymentDate: '2021-11-28',
  listOfVendors: [
    {
      vendorNo: 'T70463',
      vendorName: 'harry',
      failReason: '',
      documentId: '1234',
      amount: 100,
      transactionId: '1631896042',
      listOfInvoices: [
        {
          invoiceId: 'Invoice 123',
          amount: 12.64,
          invoiceDescription: 'xyz',
          invoiceDate: '2021-07-31',
          dueDate: '2021-07-31',
          discountAmount: 11.34,
          netAmount: 34.0,
          adjustmentAmount: 0
        },
        {
          invoiceId: 'Invoice 124',
          amount: 12.34,
          invoiceDescription: 'xyz',
          invoiceDate: '2021-07-31',
          dueDate: '2021-07-31',
          discountAmount: 11.34,
          netAmount: 66.0,
          adjustmentAmount: 0
        }
      ]
    },
    {
      vendorNo: 'TBOWK001',
      vendorName: 'potter',
      failReason: 'Email is Required. Received Empty or Null from Vendor API',
      documentId: null,
      amount: 65,
      transactionId: null,
      listOfInvoices: [
        {
          invoiceId: 'Invoice 01',
          amount: 12.34,
          invoiceDescription: 'xyz',
          invoiceDate: '2021-07-31',
          dueDate: '2021-07-31',
          discountAmount: 11.34,
          netAmount: 20.0,
          adjustmentAmount: 0
        },
        {
          invoiceId: 'Invoice 02',
          amount: 12.34,
          invoiceDescription: '',
          invoiceDate: '2021-07-31',
          dueDate: '2021-07-31',
          discountAmount: 11.34,
          netAmount: 45.0,
          adjustmentAmount: 0
        }
      ]
    },
    {
      vendorNo: 'TKIWA001',
      vendorName: 'pqr',
      failReason: 'Email is Required. Received Empty or Null from Vendor API',
      documentId: null,
      amount: 168,
      transactionId: null,
      listOfInvoices: [
        {
          invoiceId: 'Invoice 12347',
          amount: 10.0,
          invoiceDescription: 'xyz',
          invoiceDate: '2021-07-31',
          dueDate: '2021-07-31',
          discountAmount: 11.34,
          netAmount: 105.0,
          adjustmentAmount: 0
        },
        {
          invoiceId: 'Invoice 12348',
          amount: 10.0,
          invoiceDescription: 'xyz',
          invoiceDate: '2021-07-31',
          dueDate: '2021-07-31',
          discountAmount: 11.34,
          netAmount: 63.0,
          adjustmentAmount: 0
        }
      ]
    },
    {
      vendorNo: 'T7043',
      vendorName: 'abc',
      failReason:
        '404 Not Found from GET https://api-int.dit.connectcdk.com/api/ds-dms-vendor/v1/T7043',
      documentId: null,
      amount: 20,
      transactionId: null,
      listOfInvoices: [
        {
          invoiceId: 'Invoice 12346',
          amount: 12.34,
          invoiceDescription: 'xyz',
          invoiceDate: '2021-07-31',
          dueDate: '2021-07-31',
          discountAmount: 11.34,
          netAmount: 20.0,
          adjustmentAmount: 0
        }
      ]
    },
    {
      vendorNo: 'T70435',
      vendorName: 'abc',
      failReason:
        'Email is Required. Received Empty or Null from Vendor API, #Invoice 12345 is already paid, Net Amount cannot be negative.',
      documentId: null,
      amount: 23.78,
      transactionId: null,
      listOfInvoices: [
        {
          invoiceId: 'Invoice 12345',
          amount: 12.34,
          invoiceDescription: 'xyz',
          invoiceDate: '2021-07-31',
          dueDate: '2021-07-31',
          discountAmount: 11.34,
          netAmount: 23.78,
          adjustmentAmount: 0
        }
      ]
    }
  ]
};
